import { Col, Text } from 'components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const Paragraph = (props) => <Text marg="39px 0 0" {...props} />;

const CommunityGuidelines = ({}) => {
  const { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Col wid="100vw" center marg={'0px 0px 75px 0px'}>
      <Col noFlex wid={isMobile ? 'calc(100vw - 32px)' : '1140px'} center>
        <Paragraph h1 wid="100%" center>
          Community Guidelines
        </Paragraph>

        <Paragraph marg="15px 0 0">
          To maintain a fun, safe and engaging experience for all on the P4P social media
          platform(s), P4P asks that our creators and users abide by the following rules and
          guidelines. These guidelines cover P4P’s official social media accounts.
        </Paragraph>

        <Paragraph marg="15px 0 0">
          For the purposes of this document, “we,” “our” and “us” refers “Playaz4Playaz.com” and
          it’s official social media accounts and “you” or refers to individual social media users,
          including our users and creators.
        </Paragraph>

        <Paragraph marg="15px 0 0">
          Questions? Please send us a direct message through any of our social media outlets or
          email us at{' '}
          <a href="mailto:support@playaz4playaz.com">
            <i>
              <b>support@playaz4playaz.com</b>
            </i>
          </a>
          .
        </Paragraph>

        <Text h2 marg="15px 0 0">
          Treat others with respect
        </Text>

        <ul>
          <li>
            <Paragraph marg="10px 0 0">
              Posts, comments, images, videos and other content should be respectful to others.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Content that is illegal or unlawful, advocates illegal activity or is perceived as a
              threat to the wellbeing of an individual(s) will be reported to law enforcement or
              others as necessary.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Personal attacks, derogatory comments directed at individuals and the general public
              are not permitted.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Posts and comments that include a social security number, a driver’s license number or
              other information that is confidential/protected/private by law or regular are not
              permitted.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Posts and comments that are racist, sexist, homophobic or sexually explicit or
              otherwise discriminatory, threatening or harassing are not permitted.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Posts and comments with inappropriate language, including profanity, abusive language
              or obscene remarks are not permitted.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Users should not intentionally post information that is obviously false, inaccurate or
              misleading.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Any of the above content that is not permitted will be deleted by P4P administrators
              without prior notification.
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="15px 0 0">
          Don’t spam
        </Text>

        <Paragraph marg="15px 0 0">
          P4P doesn’t allow spam, scams, or other deceptive practices that take advantage of the P4P
          community. We also don’t allow content where the main purpose is to trick others into
          leaving P4P for another site.
        </Paragraph>

        <ul>
          <li>
            <Paragraph marg="10px 0 0">
              Comments should contribute to and remain relevant to the post/page to which the
              comment is directed.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Posts that solicit, advertise, endorse or promote a product or service for commercial
              purposes or personal gain and have no direct connection to P4P or would not be of
              interest to the general P4P community will be removed.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Posts or comments that are repetitive in nature will be hidden or deleted.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Posts that are endorsements or oppositions of any person or party campaigning for
              election to a political office or promoting or opposing any ballot proposal.
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="15px 0 0">
          Follow the rules
        </Text>

        <ul>
          <li>
            <Paragraph marg="10px 0 0">
              Keep in mind that all users, including creators, are subject to the Terms of Service
              (TOS) of the host site. Communications made through social technology in no way
              constitute a legal or official notice to P4P or its staff. References to third-party
              content or websites do not indicate endorsement or responsibility on behalf of P4P.
              Users who post to our site agree to comply with{' '}
              <a href="https://www.facebook.com/terms" target="_blank">
                <b>Facebook’s Terms of Service</b>
              </a>{' '}
              and all other applicable internal and external, state and federal website privacy
              statements.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              In addition, P4P staff managing or posting to social accounts must adhere to all
              appropriate P4P and social media site policies as well as P4P’s technology use policy.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              P4P employees agree to abide by all P4P the policies and procedures. If an employee
              has any questions about the P4P policies, or about other issues regarding employment,
              the employee should consult with their supervisor or the Office of Human Resources.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Individuals who violate the P4P social media platforms on any particular social media
              page will be restricted, banned or blocked from that page.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Page administrators reserve the right to remove or hide posts/comments that violate
              the social media guidelines.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Creators and social media users are solely responsible for the content they post.
              Although P4P may remove inappropriate material and restrict, ban or block certain
              individuals, we are not obligated to do so.
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="10px 0 0">
          Be safe
        </Text>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              P4P does not regularly monitor the users and followers on our social media pages or
              those of our staff or P4P divisions. Please keep this in mind while engaging with us
              online, either publicly or privately and when accepting creators, friends or users
              follow requests on your personal accounts.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              You may want to consider adjusting the privacy settings on their personal page.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Crimes, illegal activity and behavior that poses or is perceived to pose an imminent
              threat or risk of harm to anyone must be reported immediately to 911, your local
              emergency line/law enforcement. If you have general, non- threatening, concerns about
              users who follow our page, feel free to inform us.
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="10px 0 0">
          Our role/ensure proper usage rights
        </Text>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              By posting, commenting, tagging us or otherwise engaging with P4P accounts, you, the
              user, are giving us your implied unlimited permission to republish, refer to, and
              otherwise use or re-use your words and other posted content in any format or medium at
              any time and agree to creative commons, fair use and other use of public domain.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              By posting to our community, you are verifying that the content you are posting does
              not infringe on anyone else’s intellectual property rights or violate any copyrights
              or trademarks.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              By posting on our page, you are attesting that you have the right to use the posted
              content, including songs, graphics, photos, videos or other content, with the
              necessary permission from the necessary parties.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Do not use P4P’s name, marks or logo without official consent to imply official
              endorsement or impersonate Playaz4Playaz.com, or to benefit yourself financially. P4P
              has the right to defend its brand against these violations. Logos and marks may not be
              used in any way that would constitute endorsement, approval or underwriting of any
              corporation, product, activity, service or contract by P4P{' '}
              <b>We reserve the right to change these guidelines at any time</b>.
            </Paragraph>
          </li>
        </ul>
      </Col>
    </Col>
  );
};

export default CommunityGuidelines;
